import { useState } from "react";
import { useHistory } from "react-router-dom";
import './ads.css';
import ShareButton from "../shareButton/shareButton";
import { Card, CardMedia, CardContent, MobileStepper, IconButton, Button, Box, Skeleton, Tooltip } from '@mui/material';
import { KeyboardArrowLeft, KeyboardArrowRight, CalendarMonthOutlined, AccessAlarmsOutlined, EditOutlined } from '@mui/icons-material';
import { generateEventoUrl } from '../../utils/generateEventoUrl';
import { fechaEventoTexto, horaInicioTexto } from '../../utils/evento';

// hasta este ancho el inicio muestra las tarjetas chicas (variant "normal")
export const MEDIA_MOBILE = "(max-width:770px)";

const CardPublicacion = ({
  publicacion,
  isLoading,
  variant = "normal",
  // con onEditar la tarjeta no navega (sólo "Ver más"), para que un click
  // errado cerca del lápiz no saque de la pantalla
  onEditar,
}) => {
  const gestion = Boolean(onEditar);
  const [activeIndex, setActiveIndex] = useState(0);
  const history = useHistory();
  const maxSteps = publicacion?.attachs?.length || 0;

  const next = () => {
    const nextIndex = activeIndex === publicacion.attachs?.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };

  const previous = () => {
    const nextIndex = activeIndex === 0 ? publicacion.attachs?.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  };

  const handleIconClick = (e) => {
    e.stopPropagation();
  };

  const irAlEvento = () => {
    history.push(generateEventoUrl({ id: publicacion.idevento, evento: publicacion.evento.evento }));
  };

  const lapiz = gestion && (
    <Tooltip title="Editar publicación">
      <IconButton
        size="small"
        aria-label="Editar publicación"
        onClick={(e) => {
          e.stopPropagation();
          onEditar();
        }}
        sx={{ color: "#5656FF", flexShrink: 0, p: 0.5 }}
      >
        <EditOutlined fontSize="small" />
      </IconButton>
    </Tooltip>
  );

  if (isLoading) {
    return (
      <Box sx={{ width: 350, my: 4 }}>
        <Skeleton variant="rectangular" width="100%" height={200} />
        <Box sx={{ pt: 0.5 }}>
          <Skeleton height={60} />
          <Skeleton />
          <Skeleton width="60%" />
        </Box>
      </Box>
    );
  }

  if (variant === "solo") {
    return (
      <div className="mt-4 contenedor-card" style={{ display: "flex", justifyContent: "center" }}>
        <Card
          className="card-publicacion-indiv"
          sx={{
            boxShadow: 'none',
            borderRadius: "10px",
            padding: "5px",
            cursor: gestion ? "default" : "pointer",
          }}
          onClick={gestion ? undefined : irAlEvento}
        >
          {publicacion.attachs && publicacion.attachs.length > 0 && (
            <div style={{ position: 'relative', height: "100%", maxHeight: "300px" }}>
              <CardMedia
                sx={{
                  width: "370px",
                  cursor: gestion ? "default" : "pointer",
                  transition: 'transform 0.2s ease-in-out',
                  '&:hover': gestion ? {} : {
                    transform: 'scale(1.02)',
                  }
                }}
                className="media-publicacion-indiv"
                component={publicacion.attachs[activeIndex].url.includes("video") ? "video" : "img"}
                src={publicacion.attachs[activeIndex].url}
                alt={publicacion.titulo}
                controls={publicacion.attachs[activeIndex].url.includes("video")}
                onClick={gestion ? undefined : irAlEvento}
              />
              {maxSteps > 1 && (
                <>
                  <IconButton
                    style={{
                      position: 'absolute',
                      left: 0,
                      top: '50%',
                      transform: 'translateY(-50%)',
                      color: "#5656FF"
                    }}
                    onClick={(e) => {
                      handleIconClick(e);
                      previous();
                    }}
                  >
                    <KeyboardArrowLeft />
                  </IconButton>
                  <IconButton
                    style={{
                      position: 'absolute',
                      right: 0,
                      top: '50%',
                      transform: 'translateY(-50%)',
                      color: "#5656FF"
                    }}
                    onClick={(e) => {
                      handleIconClick(e);
                      next();
                    }}
                  >
                    <KeyboardArrowRight />
                  </IconButton>
                  <MobileStepper
                    steps={maxSteps}
                    position="static"
                    activeStep={activeIndex}
                    style={{
                      background: 'transparent',
                      position: 'absolute',
                      bottom: 0,
                      width: '100%',
                    }}
                    nextButton={<div />}
                    backButton={<div />}
                  />
                </>
              )}
            </div>
          )}

          <CardContent className="contenido-publicacion-indiv">
            <div className="d-flex align-items-center gap-1">
              <p className="title-publicacion-indiv">
                {publicacion.titulo}
              </p>
              {lapiz}
            </div>

            <div className="d-flex justify-content-between align-items-center mb-1">
              <div className="fechaHora-publicacion">
                <div className="fecha-publicacion d-flex align-items-center">
                  <CalendarMonthOutlined fontSize="small" sx={{ marginRight: "5px" }} />
                  <small>
                    {fechaEventoTexto(publicacion.evento, "D [de] MMM")}
                  </small>
                </div>
                <div className="d-flex align-items-center">
                  <AccessAlarmsOutlined fontSize="small" sx={{ marginRight: "5px" }} />
                  <small>{horaInicioTexto(publicacion.evento)}</small>
                </div>
              </div>
            </div>

            <p className="mb-0">
              Lugar: {publicacion.evento?.direccion}
            </p>

            <p className="descripcion">
              {publicacion.descripcion.length > 85
                ? `${publicacion.descripcion.substring(0, 85)}...`
                : publicacion.descripcion
              }
            </p>

            <div>
              <div className="d-flex align-items-center justify-content-end gap-3" onClick={handleIconClick}>
                <ShareButton
                  idEvento={publicacion.idevento}
                  eventoNombre={publicacion.evento?.evento}
                  style={{ color: "#5656FF" }}
                />
                <Button
                  sx={{
                    fontSize: '16px',
                    padding: '8px 15px',
                    backgroundColor: '#5656FF',
                    color: 'white',
                    borderRadius: '8px',
                    '&:hover': {
                      backgroundColor: '#3939AA',
                    },
                  }}
                  onClick={irAlEvento}
                >
                  Ver más
                </Button>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    );
  }

  // normal (cards pequeñas)
  return (
    <div className="mt-4 contenedor-card-normal">
      <Card
        className="card-publicacion"
        sx={{
          boxShadow: 'none',
          cursor: gestion ? "default" : "pointer",
          ...(gestion && { '&:hover': { transform: 'none !important' } }),
        }}
        onClick={gestion ? undefined : irAlEvento}
      >
        {publicacion.attachs && publicacion.attachs.length > 0 && (
          <div style={{ position: 'relative' }}>
            <CardMedia
              className="media-publicacion"
              component={publicacion.attachs[activeIndex].url.includes("video") ? "video" : "img"}
              src={publicacion.attachs[activeIndex].url}
              alt={publicacion.titulo}
              controls={publicacion.attachs[activeIndex].url.includes("video")}
            />
            {maxSteps > 1 && (
              <>
                <IconButton
                  style={{
                    position: 'absolute',
                    left: 0,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    color: "#5656FF"
                  }}
                  onClick={(e) => {
                    handleIconClick(e);
                    previous();
                  }}
                >
                  <KeyboardArrowLeft />
                </IconButton>
                <IconButton
                  style={{
                    position: 'absolute',
                    right: 0,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    color: "#5656FF"
                  }}
                  onClick={(e) => {
                    handleIconClick(e);
                    next();
                  }}
                >
                  <KeyboardArrowRight />
                </IconButton>
                <MobileStepper
                  steps={maxSteps}
                  position="static"
                  activeStep={activeIndex}
                  style={{
                    background: 'transparent',
                    position: 'absolute',
                    bottom: 0,
                    width: '100%',
                  }}
                  nextButton={<div />}
                  backButton={<div />}
                />
              </>
            )}
          </div>
        )}

        <CardContent className="contenido-publicacion">
          <div>
            <div className="d-flex align-items-center gap-1">
              <p className="title-publicacion">
                {publicacion.titulo}
              </p>
              {lapiz}
            </div>

            <div className="fechaHora-publicacion">
              <div className="fecha-publicacion d-flex align-items-center">
                <CalendarMonthOutlined
                  fontSize="small"
                  sx={{ marginRight: "5px" }}
                />
                <small>
                  {fechaEventoTexto(publicacion.evento, "D [de] MMM")}
                </small>
              </div>
              <div className="d-flex align-items-center">
                <AccessAlarmsOutlined
                  fontSize="small"
                  sx={{ marginRight: "5px" }}
                />
                <small>
                  {horaInicioTexto(publicacion.evento)}
                </small>
              </div>
            </div>

            <p className="descripcion">
              {publicacion.descripcion.length > 70
                ? `${publicacion.descripcion.substring(0, 70)}...`
                : publicacion.descripcion
              }
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default CardPublicacion;